import app, { Component } from 'apprun';
import { isValidElement, showSaveStatusMessage } from '../utils';
import { contractOption } from '../api';
import moment from 'moment';
import { lookup_en } from '../utils';

export default class CommonPropertyComponent extends Component {
  dateFmt = 'DD-MMM-YYYY';

  state = { contractOptions: [] };

  Item = ({ item, startDateEnable, endDateEnable }) => {
    return (
      <tr
        style={{ display: 'table-row' }}
        onclick={
          !item.locked
            ? (e) => {
              this.run('contractOption-edit', item, startDateEnable, endDateEnable, e);
            }
            : ''
        }>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.contractOptionID}
          </span>
        </td>

        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.startDate ? moment.utc(item.startDate).format(this.dateFmt) : ''}
          </span>
        </td>
        <td>
          <span class="form-text" style={{ 'max-width': '200px' }}>
            {item.endDate ? moment.utc(item.endDate).format(this.dateFmt) : ''}
          </span>
        </td>
        <td>
          <td>
            <i class="control-label glyphicon glyphicon-pencil" />
          </td>
        </td>
      </tr>
    );
  };

  List = ({ state }) => {
    return (
      <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover">
        <thead>
          <tr>
            <th>Contract Option</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          {state.contractOptions.map((item, index) => (
            <this.Item
              item={item}
              startDateEnable={index === 0}
              endDateEnable={index === state.contractOptions.length - 1}
            />
          ))}
        </tbody>
      </table>
    );
  };

  ContractOptionHistory = ({ state }) => {
    return (
      <div>
        <div style={{ 'white-space': 'normal', 'word-wrap': 'break-word' }}>
          <this.List state={state} />
        </div>
      </div>
    );
  };

  ContractOptionEdit = ({ state }) => {
    let selectOptions = lookup_en['ContractOption'];
    selectOptions = selectOptions || [];

    return (
      <div style={{ display: state.editingContractOption ? 'disp' : 'none' }}>
        <div class="row" style={{ display: state.newContractOption ? 'disp' : 'none' }}>
          **NEW**
        </div>
        <div class="row">
          <label class="col-sm-5">Contract Option</label>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <select
              id="ContractOptionId"
              class="form-control"
              oninput={e => (state.editingContractOptionId = e.target.value)}>
              {selectOptions.map(p => (
                <option
                  value={p.id}
                  selected={
                    p.id.toString().toUpperCase() ===
                    (state.editingContractOptionId ? state.editingContractOptionId : '').toString().toUpperCase()
                      ? 'selected'
                      : null
                  }>
                  {p.value}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div class="row">
          <div id="ContractOptionIdErrMsg" class="text-danger, col-sm-6"></div>
        </div>

        <div class="row">
          <label class="col-sm-5">Start Date</label>
          <label class="col-sm-5">End Date</label>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <input
              $pikaday
              id="contractOptionStartDate"
              size="62"
              class="form-control"
              value={state.contractOptionStartDate}
              disabled={!state.startDateEnable}
            />
          </div>
          <div class="col-sm-5">
            <input
              $pikaday
              id="contractOptionEndDate"
              size="62"
              class="form-control"
              value={state.contractOptionEndDate}
              disabled={!state.endDateEnable}
            />
          </div>
        </div>
        <div class="row">
          <div id="contractOptionStartDateErrMsg" class="text-danger, col-sm-5"></div>
          <div id="contractOptionEndDateErrMsg" class="text-danger, col-sm-5"></div>
        </div>
        <div class="row">
          <div id="contractOptionReturnedErrMsg" class="text-danger, col-sm-5">
            {state.contractOptionSaveError}
          </div>
        </div>
        <br />
        <div>
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('contractOption-edit-save')}>
            Save
          </a>

          <a
            type="button"
            class="btn btn-primary btn-xs"
            onclick={() => this.run('contractOption-edit-delete')}
            style={{
              display: !state.newContractOption && (state.startDateEnable || state.endDateEnable) ? 'disp' : 'none',
            }}>
            Delete
          </a>

          <a type="button" class="btn btn-default btn-xs" onclick={() => this.run('contractOption-edit-cancel')}>
            Cancel
          </a>
        </div>
      </div>
    );
  };

  // prettier-ignore
  view = (state) => {
    //this.log('In view of common-props-date-edit...');
    //this.log(state);
    return (
      <div style={{ width: '550px' }}>
        <this.ContractOptionHistory state={state} />
        <div>
          <a type="button" class="btn btn-primary btn-xs" onclick={e => this.run('contractOption-new', e)}>
            +New
          </a>
        </div>
        <br/>
        <this.ContractOptionEdit state={state} />
      </div>
    );
  };

  update = {
    refresh: async (state, newState) => {
      state.locationId = newState.caller.state.locationId;
      state.contractOptions = await contractOption.get(state.locationId);

      return { ...state, ...newState };
    },

    'contractOption-new': (state, e) => {
      //this.log('In commProg-new...');
      //this.log(state);
      this.run('contractOption-edit', { contractOptionID: 0 }, true, true, e);
    },

    'contractOption-edit': (state, item, startDateEnable, endDateEnable) => {

      state.contractOptionStartDate = item.startDate ? moment.utc(item.startDate).format(this.dateFmt) : '';
      state.contractOptionEndDate = item.endDate ? moment.utc(item.endDate).format(this.dateFmt) : '';

      state.startDateEnable = startDateEnable;
      state.endDateEnable = endDateEnable;

      state.oldStartDate = state.contractOptionStartDate;
      state.oldEndDate = state.contractOptionEndDate;
      state.oldContractOptionId = item.contractOptionID;

      state.newContractOption = item.contractOptionID === 0;

      state.editingContractOption = true;
      state.editingContractOptionId = item.contractOptionID;
      state.contractOptionUnderEdit = item;

      state.oldStartDate = state.contractOptionStartDate;
      state.oldEndDate = state.contractOptionEndDate;
      state.oldContractOptionId = item.contractOptionID;

      return state;
    },

    'contractOption-edit-save': async (state) => {
      document.getElementById('ContractOptionIdErrMsg').innerHTML = '';
      document.getElementById('contractOptionStartDateErrMsg').innerHTML = '';
      document.getElementById('contractOptionEndDateErrMsg').innerHTML = '';

      document.getElementById('contractOptionReturnedErrMsg').innerHTML = '';

      state.contractOptionSaveError = null;
      const contractOptionReturnedErrMsgDiv = document.getElementById('contractOptionReturnedErrMsg') as HTMLDivElement;
      contractOptionReturnedErrMsgDiv.innerHTML = state.contractOptionSaveError;

      state.contractOptionStartDate = (document.getElementById(
        'contractOptionStartDate'
      ) as HTMLInputElement).value.trim();
      state.contractOptionEndDate = (document.getElementById('contractOptionEndDate') as HTMLInputElement).value.trim();

      const element = document.getElementById('ContractOptionId') as HTMLInputElement;

      let valid = true;

      if (element.value === '0') {
        valid = false;
        const errMsg = document.getElementById('ContractOptionIdErrMsg') as HTMLDivElement;
        errMsg.innerHTML = 'Please select contract option.';
      }

      if (state.contractOptionStartDate === '') {
        valid = false;
        const errMsg = document.getElementById('contractOptionStartDateErrMsg') as HTMLDivElement;
        errMsg.innerHTML = 'Start date cannot be empty.';
      } else {
        valid = valid && isValidElement('contractOptionStartDate', 'DateStr');
      }

      if (state.contractOptionEndDate === '') {
        valid = false;
        const errMsg = document.getElementById('contractOptionEndDateErrMsg') as HTMLDivElement;
        errMsg.innerHTML = 'End date cannot be empty.';
      } else {
        valid = valid && isValidElement('contractOptionEndDate', 'DateStr');
      }

      if (
        valid &&
        moment(state.contractOptionStartDate, this.dateFmt) > moment(state.contractOptionEndDate, this.dateFmt)
      ) {
        valid = false;
        const errMsg = document.getElementById('contractOptionEndDateErrMsg') as HTMLDivElement;
        errMsg.innerHTML = 'End date cannot be before Start date';
      }

      if (
        valid &&
        state.oldContractOptionId === 0 &&
        state.contractOptions.length > 0 &&
        !moment(state.contractOptionEndDate, this.dateFmt).isSame(
          moment(state.contractOptions[0].startDate).add(-1, 'days')
        ) &&
        !moment(state.contractOptionStartDate, this.dateFmt).isSame(
          moment(state.contractOptions[state.contractOptions.length - 1].endDate).add(1, 'days')
        )
      ) {
        valid = false;
        const errMsg = document.getElementById('contractOptionStartDateErrMsg') as HTMLDivElement;
        errMsg.innerHTML = 'Date is invalid.';
      }

      if (valid) {
        const optionToSave = {
          newContractOptionId: parseInt(state.editingContractOptionId),
          newStartDate: state.contractOptionStartDate,
          newEndDate: state.contractOptionEndDate,
          oldStartDate: state.oldStartDate,
          oldEndDate: state.oldEndDate,
          oldContractOptionId: state.oldContractOptionId,
        };

        let result;
        try {
          result = await contractOption.upsertContractOption(state.locationId, optionToSave);
          showSaveStatusMessage('contract option');
        } catch (ex) {
          showSaveStatusMessage();
          const errorMsg = await ex.json();
          state.contractOptionSaveError = '* ' + errorMsg;
          return state;
        }

        if (result) {
          state.contractOptions = await contractOption.get(state.locationId);
          state.caller.run('refresh', state.locationId);
          this.run('contractOption-edit-cancel');
        }
      }
    },

    'contractOption-edit-delete': async (state) => {
      document.getElementById('ContractOptionIdErrMsg').innerHTML = '';
      document.getElementById('contractOptionStartDateErrMsg').innerHTML = '';
      document.getElementById('contractOptionEndDateErrMsg').innerHTML = '';
      document.getElementById('contractOptionReturnedErrMsg').innerHTML = '';

      state.contractOptionSaveError = null;
      const contractOptionReturnedErrMsgDiv = document.getElementById('contractOptionReturnedErrMsg') as HTMLDivElement;
      contractOptionReturnedErrMsgDiv.innerHTML = state.contractOptionSaveError;

      const optionToSave = {
        oldStartDate: state.oldStartDate,
        oldEndDate: state.oldEndDate,
        oldContractOptionId: state.oldContractOptionId,
      };

      let result;
      try {
        result = await contractOption.deleteContractOption(state.locationId, optionToSave);
        showSaveStatusMessage('contract option');
      } catch (ex) {
        showSaveStatusMessage();
        const errorMsg = await ex.json();
        state.contractOptionSaveError = '* ' + errorMsg;
        return state;
      }

      if (result) {
        state.contractOptions = await contractOption.get(state.locationId);
        state.caller.run('refresh', state.locationId);
        this.run('contractOption-edit-cancel');
      }
    },

    'contractOption-edit-cancel': (state) => {
      state.editingContractOption = false;
      state.contractOptionUnderEdit = null;
      state.editingContractOptionId = null;

      return state;
    },
  };
  rendered = (state) => {
    return { ...state, editingContractOption: false, contractOptionStartDate: '', contractOptionEndDate:'',startDateEnable:true, endDateEnable:true };
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
